import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import { Box, Stack, Text } from '@atlaskit/primitives/compiled';
import { LinkList } from '@atlassian/smart-knowledge-cards/link-list';

const messages = defineMessages({
	recentWorkHeading: {
		id: 'user-profile-card.recent-work.heading',
		defaultMessage: 'Recent work',
		description: 'Section title for recent work smart links on the user profile card',
	},
});

interface RecentWorkSectionProps {
	recentWorkData: string[];
	testId?: string;
	viewAllUrl?: string;
	onLinkClick?: (url: string, index: number) => void;
	onViewAllLinkClick?: () => void;
}

export function RecentWorkSection({
	recentWorkData,
	testId,
	viewAllUrl,
	onLinkClick,
	onViewAllLinkClick,
}: RecentWorkSectionProps): React.JSX.Element | null {
	const intl = useIntl();

	if (recentWorkData.length === 0) {
		return null;
	}

	return (
		<Stack space="space.075">
			<Text as="p" weight="medium" size="small" color="color.text">
				{intl.formatMessage(messages.recentWorkHeading)}
			</Text>
			<Box testId={testId}>
				<LinkList
					urls={recentWorkData}
					size="compact"
					maxSources={3}
					showExpand={false}
					viewAllUrl={viewAllUrl}
					onViewAllLinkClick={onViewAllLinkClick}
					onLinkClick={onLinkClick}
				/>
			</Box>
		</Stack>
	);
}
